<template>
  <svg
    class="voice-icon"
    :class="directionName"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
  >
    <path
      v-show="flag[0]"
      d="M344.96 362.647l-146.526 150.83L347.89 664.314c79.122-82.808 79.122-218.856-2.93-301.667z"
      :fill="color"
    />
    <path
      v-show="flag[1]"
      d="M494.413 214.765l-73.263 73.941c123.083 124.215 123.083 325.328 0 449.546l73.263 73.938c164.11-165.625 164.11-431.797 0-597.425z"
      :fill="color"
    />
    <path
      v-show="flag[2]"
      d="M640.944 63.934l-73.266 73.941c205.138 207.023 205.138 541.221 0 748.256l73.266 73.935c246.163-245.478 246.163-647.699 0-896.132z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  data() {
    return {
      flag: [1, 1, 1],
      timer: null
    }
  },
  props: {
    color: {
      type: String,
      default: '#333333'
    },
    duration: {
      type: Number,
      default: 300
    },
    active: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: 'right'
    }
  },
  computed: {
    directionName() {
      return 'is-' + this.direction
    }
  },
  watch: {
    active: {
      handler(n) {
        if (n) {
          this.changFlags()
        } else {
          this.clearTimer()
        }
      },
      immediate: true
    }
  },
  methods: {
    changFlags() {
      let i = 0
      const flagList = [
        [1, 0, 0],
        [1, 1, 0],
        [1, 1, 1]
      ]
      this.flag = flagList[i % 3]
      this.timer = setInterval(() => {
        this.flag = flagList[i % 3]
        i++
      }, this.duration)
    },
    clearTimer() {
      clearInterval(this.timer)
      this.timer = null
      this.flag = [1, 1, 1]
    }
  },
  created() {
  },
  beforeDestroy() {
    this.clearTimer()
  }
}
</script>

<style lang="stylus" scoped>
.voice-icon {
  &.is-left {
    transform: rotate(180deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/voiceIcon.vue